/** #################################### Generated content ####################################
 * This block has been generated with deppy create-index (for more information https://github.com/webedx-spark/deppy)
 **/

export const TutorialHubPageDynamic = () => import('./components/TutorialHubPage');
export const TutorialPageDynamic = () => import('./components/TutorialPage');

/**
 *  #################################### Generated content ####################################
 **/
